export default {
  FETCH_QUESTION_ANSWERS(state, data) {
    state.questionAnswers = data
  },

  SET_QUESTION_ANSWER_LOADING(state, status) {
    state.questionAnswerLoading = status
  }
}
